import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[panelTitle]',
  standalone: true
})
export class PanelTitleDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
